module.exports = __webpack_public_path__ + "static/media/facebookIcon.bd515bc5.png";